import {
  ApiBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  oktaAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { almaApiRef } from './types';
import { AlmaRestApi } from './apis';

// ── API (→ global API registry) ─────────────────────────
const almaApi = ApiBlueprint.make({
  name: 'alma-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: almaApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          oktaApi: oktaAuthApiRef,
        },
        factory: ({ discoveryApi, fetchApi, oktaApi }) =>
          new AlmaRestApi({ discoveryApi, fetchApi, oktaApi }),
      }),
    ),
});

// The Alma launcher is registered as an app root wrapper in the app module:
// app root elements also render on the sign-in page.
export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-alma',
  extensions: [almaApi],
});
